import { render, staticRenderFns } from "./UserMyPhones.vue?vue&type=template&id=0b92098b"
import script from "./UserMyPhones.vue?vue&type=script&lang=js"
export * from "./UserMyPhones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports